import { observer } from 'mobx-react-lite'
import { InventoryItemFormContainer } from '@/features/inventory/admin/components/InventoryItemForm/InventoryItemFormContainer'
import { type EditInventoryItemDialogViewModel } from './EditInventoryItemDialogViewModel'

export interface EditInventoryItemDialogContainerProps {
  vm: EditInventoryItemDialogViewModel
}

export const EditInventoryItemDialogContainer = observer(
  function EditInventoryItemDialogContainer({
    vm,
  }: EditInventoryItemDialogContainerProps) {
    return (
      <InventoryItemFormContainer
        vm={vm}
        title="Edit service item"
        submitText="Update item"
        overridden={vm.item?.override}
        editing
      />
    )
  },
)
